import { DateTime } from 'luxon';
import getComparisonPreviousFiscalEntities from './getComparisonPreviousFiscalEntities';
import getComparisonLastYearFiscalEntities from './getComparisonLastYearFiscalEntitites';

const getFiscalComparison = (
  startDate: DateTime,
  endDate: DateTime | undefined,
  comparison: PersistedComparisonType,
  interval: FixedPeriods.FiscalType,
  relativeDateRange: RelativeDateRange,
  allFiscals?: FixedPeriods.AllFiscals,
): { startDate?: DateTime; endDate?: DateTime } => {
  if (!allFiscals) {
    const e = new Error();
    e.message = 'getFiscalComparison: No fiscal periods found';
    e.name = 'NoFiscalPeriodsFound';
    throw e;
  }
  if (comparison.compareType === 'previous') {
    const intervalAmount =
      relativeDateRange.type === 'current' ? 1 : relativeDateRange.n;
    return getComparisonPreviousFiscalEntities(
      startDate,
      intervalAmount,
      interval,
      relativeDateRange.currentToDate,
      allFiscals,
    );
  } else if (comparison.compareType === 'lastYear') {
    return getComparisonLastYearFiscalEntities(
      startDate,
      endDate,
      interval,
      relativeDateRange.currentToDate,
      allFiscals,
    );
  }
  return {
    startDate,
    endDate,
  };
};

export default getFiscalComparison;
